<template>
  <component
    :is="component"
    :value="value"
    class="kvass-image-text"
    :class="['kvass-image-text--theme-' + theme.toLowerCase()]"
    v-bind="$attrs"
  >
    <template #content="item">
      <slot name="content" v-bind="item" />
    </template>
  </component>
</template>

<script>
import Themes from './Themes'
import { Capitalize } from './utils'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: String,
      default: 'sections',
      validator(val) {
        return Object.keys(Themes).includes(Capitalize(val))
      },
    },
  },
  computed: {
    component() {
      return Themes[Capitalize(this.theme)]
    },
  },
}
</script>
